import * as React from 'react';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import {ProductType, productType} from '../../infrastructure/ProductType';
import {setNewProductProductType} from "../../actions/actions";
import {avaliableDocTypes} from "../App/config";

const bulletinLogo = require('./images/Bulletin.svg');
const brochureLogo = require('./images/Brochure.svg');
const catalogLogo = require('./images/Catalog.svg');

export interface ICreateProductLandingPageProps {
    setNewProductType(prodType: ProductType): void;
}

export interface ICreateProductLandingPageState {
}

const mapStateToProps = (state: any) => {
    return {
    };
};

const mapDispatchToProps = (dispatch: any): any => {
    return {
        setNewProductType: (type: ProductType): void => {
            dispatch(setNewProductProductType(type));
        },
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class CreateProductLandingPage extends React.Component<ICreateProductLandingPageProps> {

    click(type: ProductType, history: any) {
        //Set the type (Bulletin, Catalog, brochure)
        this.props.setNewProductType(type);

        history.push('/CreateProductTemplatePicker');
    }

    renderPortal(title: string, isEnabled: boolean, type: any, image?: string, description?: string): any {
        return (
            <Route
                render={({history}) => (
                    <div>
                        <button
                            disabled={!isEnabled}
                            className="portal"
                            onClick={() => this.click(type, history)}>

                            <div className="portal-wrapper">
                                <div className="portal-logo">
                                    <img src={image}/>
                                </div>
                                <div className="portal-title">
                                    <span>{title}</span>
                                    <div>{description}</div>
                                </div>
                            </div>
                        </button>
                    </div>)
                }/>
        );
    }

    render() {
        return (
            <div className="createProductLp-wrapper">
                <div className="createProductLp-header">
                    <div className="lp-headline">Choose the Guide You Want to Build</div>
                    <div className="optionText">Click one option below</div>
                </div>
                <div className="createProductLp-body">
                    {this.renderPortal('Bulletin', avaliableDocTypes.bulletin, productType.Bulletin, bulletinLogo, 'Single Product')}
                    {this.renderPortal('Quad Fold', avaliableDocTypes.brochure, productType.Brochure, brochureLogo, 'Up to 8 Products')}
                    {this.renderPortal('Catalog', avaliableDocTypes.catalog, productType.Catalog, catalogLogo)}
                    {this.renderPortal('Seed', avaliableDocTypes.seed, productType.Seed, catalogLogo)}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateProductLandingPage/CreateProductLandingPage.tsx